const gridTableStyle = {
  root: {
    width: '100%',
  },
  tableContainerStyle: {
    width: '100%',
    height: '100%',
    margin: 'auto',

    border: '1px solid #FFFFFF',
    boxShadow: '4px -4px 12px #FFFFFF, -4px 4px 12px rgba(0, 0, 0, 0.15)',
    borderRadius: '2px',
    // overflowX: 'clip',
  },
  cell: {
    '@media print': {
      // backgroundColor: '#FFFFFF !important',
      border: '1px solid #DADADA !important',
    },
    border: '1.5px solid rgba(249, 250, 251, 1) !important',
  },
  textWeek: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '10px',
    height: '40px',
    // height: 'auto',

    fontFamily: 'dana-bold',
    textAlign: 'center',
    color: 'rgba(117, 60, 190, 1)',
    ['@media (min-width:600px)']: {
      // eslint-disable-line no-useless-computed-key
      fontSize: '14px',
      margin: '5px',
    },
  },
  textHour: {
    fontSize: '12px',

    fontFamily: 'dana-bold',
    textAlign: 'center',
    color: '#707070',
    ['@media (min-width:600px)']: {
      // eslint-disable-line no-useless-computed-key
      fontSize: '16px',
    },
  },
  glucoseText: {
    fontSize: '10px',

    fontFamily: 'dana-bold',
    textAlign: 'center',
    color: '#707070',
    ['@media (min-width:600px)']: {
      // eslint-disable-line no-useless-computed-key
      fontSize: '16px',
    },
  },
  glucoseDot: {
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'center',
  },
  prev_next_Text: {
    '@media print': {
      display: 'none',
    },
    fontSize: '12px',

    fontWeight: '400',
    textAlign: 'center',
    color: '#3CC0C3',
    ['@media (min-width:600px)']: {
      // eslint-disable-line no-useless-computed-key
      fontSize: '16px',
    },
  },
  arrowIcons: {
    '@media print': {
      display: 'none',
    },
    color: '#3CC0C3',
    background: '#FFFFFF',
    boxShadow:
      '1.5px 1.5px 3px rgba(174, 174, 192, 0.4), -1px -1px 3px #FFFFFF',
    borderRadius: '4px',
    width: '18px !important',
    height: '18px !important',
    ['@media (min-width:600px)']: {
      // eslint-disable-line no-useless-computed-key
      width: '22px !important',
      height: '22px !important',
    },
  },

  disableIcon: {
    color: '#707070',
    opacity: '0.6',
  },

  prev_next_week: {
    '@media print': {
      display: 'none',
    },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  activeWeekText: {
    '@media print': {
      display: 'none',
    },
    fontSize: '14px',

    fontFamily: 'dana-bold',
    textAlign: 'center',
    color: '#707070',
    ['@media (min-width:600px)']: {
      // eslint-disable-line no-useless-computed-key
      fontSize: '16px',
    },
  },
};
export default gridTableStyle;
